<template>
  <TarjetaDatos titulo="Capitales">
    <Campo2L v-if="poliza.negCteInmueble" :valor="poliza.negCteInmueble | currencyEUR" etiqueta="Continente" />
    <Campo2L v-if="poliza.negCteReforma" :valor="poliza.negCteReforma" etiqueta="Reforma" />
    <Campo2L v-if="poliza.negMobiliario" :valor="poliza.negMobiliario | currencyEUR" etiqueta="Mobiliario" />
    <Campo2L v-if="poliza.negExistencias" :valor="poliza.negExistencias | currencyEUR" etiqueta="Existencias" />
    <Campo2L v-if="poliza.negRecetas" :valor="poliza.negRecetas | currencyEUR" etiqueta="Recetas" />
  </TarjetaDatos>
</template>

<script>
export default {
  props: {
    poliza: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped></style>
